module.exports = __webpack_public_path__ + "img/avatar_random_10.3f7ef50a.png";